
export class dawaCollector {


   static ejerlavFraKode(ejerlavskode: string | number): Promise<DawaEjerlav> {
      return fetchDawa("ejerlav/" + ejerlavskode) as Promise<DawaEjerlav>;
   }

}

function fetchDawa(endpoint: string, query?: { [key: string]: any }): Promise<any> {
   const serviceUrl = `https://api.dataforsyningen.dk/${endpoint}` + (query ? `?${new URLSearchParams(query)}` : "");
   return fetch(serviceUrl, {
      method: 'GET',
      headers: {
         'Accept': 'application/json'
      }
   }).then(async res => {
      if (!res.ok) {
         await res.text().then(text => {
            console.error("Error response from DAWA:", text);
         });
         throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json() as Promise<unknown>;
   });
}

type DawaEjerlav = typeof ejerlavExample;
const ejerlavExample = {
   "href": "https://api.dataforsyningen.dk/ejerlav/14352",
   "kode": 14352,
   "navn": "Løjtegård, Korsvejen",
   "bbox": [
      12.61704236,
      55.6268154,
      12.6237062,
      55.62782559
   ],
   "visueltcenter": [
      12.62258711,
      55.62726152
   ]
}